import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function putUnits({ body, id }) {
  return BaseService.put(REST.UNITS_ID(id), body);
}

function getUnits(params) {
  return BaseService.get(REST.UNITS, {
    params: paramsFilter({ params }),
  });
}

export default {
  getUnits,
  putUnits,
};
